let competitionList=[
    {
        title:"Huawei Developer Competition 2023 APAC",
        place:"Place : Top 50",
        link:"https://competition.intl.huaweicloud.com/intl/en-us/information/1201724739/shortlisting",
        orgernizer:'Huwaie'
    },
    {
        title:"The Great Debate - Red Cloud Summit at Infotel ICT Expo 2023",
        place:"Place : Runners-Up",
        link:"https://www.linkedin.com/posts/manuja-dewmina-8b0173205_redcloudsummit-cloudsecurity-teamengineering-activity-7139542582648307712-Hp2n?utm_source=share&utm_medium=member_desktop",
        orgernizer:'Orel'
    },
    
];

const CompetitionData={competitionList};
export default CompetitionData;